import { StyledLabelOnBox, StyledLabelText } from './style';

export const StateLabelOnBox = () => (
  <StyledLabelOnBox>
    <StyledLabelText>On</StyledLabelText>
  </StyledLabelOnBox>
);
